export function mapPlans(subscriptionProduct, subscriptionData) {
  if (!subscriptionProduct || typeof subscriptionProduct !== "object") return [];

  const PLAN_ORDER = ["free trial", "starter", "growth", "pro"];

  const currentPlanName = (subscriptionData?.subscription?.name || "").toLowerCase().trim();
  const currentInterval = subscriptionData?.subscription?.recurring_interval;

  const currentIndex = PLAN_ORDER.indexOf(currentPlanName);

  let list = Object.keys(subscriptionProduct).map((key) => {
    const group = subscriptionProduct[key];
    return {
      key,
      title: group.displayName || key,
      monthly: group.monthly || null,
      yearly: group.yearly || null,
      order: PLAN_ORDER.indexOf(key.toLowerCase())
    };
  });

  list = list.filter(item => {
    const itemIndex = item.order;

    if (currentInterval === 1) {
      if (itemIndex > currentIndex) return true;
      return false;
    }

    if (currentInterval === 2) {
      if (itemIndex > currentIndex) return true; 
      return false; 
    }

    return true;
  });

  if (currentInterval === 1) {
    const currentPlanKey = currentPlanName;
    const currentPlanGroup = subscriptionProduct[currentPlanKey];

    if (currentPlanGroup) {
      list.push({
        key: currentPlanKey,
        title: currentPlanGroup.displayName,
        monthly: null,
        yearly: currentPlanGroup.yearly,
        order: PLAN_ORDER.indexOf(currentPlanKey),
        isCurrentIncludedInYearly: true
      });
    }
  }

  list.sort((a, b) => a.order - b.order);

  return list;
}
